import { On3IconMasseyRatings } from '@on3/icons';

import styles from './MasseyRatings.module.scss';

type MasseyRatingsType = 'data' | 'prediction';

interface IMasseyRatingsProps {
  type?: MasseyRatingsType;
}

export const MasseyRatings = ({ type = 'data' }: IMasseyRatingsProps) => {
  return (
    <figure className={styles.block}>
      {type === 'data' && <span>Data provided by</span>}
      <On3IconMasseyRatings />
      {type === 'prediction' && <span>Prediction accuracy</span>}
    </figure>
  );
};
